export default "__VITE_ASSET__dfuHp9pu__"